module.exports = __webpack_public_path__ + "static/media/slider-bg-pic4.bc010ac1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/slider-bg-pic4.jpg
// module id = 249
// module chunks = 0